<template>
    <section class="menu2-box">
        <div class="menu2">
            <ul>
                <li v-for="(item,index) in menus" :key="index" :class="curName == item.name ? 'activity' :''" ><a @click="$router.push(item.url)" href="javascript:void(0)">{{item.name}}</a></li>             
            </ul>
        </div>
    </section>
</template>
<script>
export default {
    name:"Menu",
    data(){
        return{
            menus:[
                {name:'首页',url:'/'},
                {name:'全部课程',url:'/course/index'},
                {name:'祈山名师',url:'/teachers/index'},
                {name:'新闻资讯',url:'/news/index'},
                {name:'关于我们',url:'/about/index'},
            ]
        }
    },
    props:{
        curName:''
    }
}
</script> 
